module.exports = __webpack_public_path__ + "static/media/veggie-min.677ef07d.png";